import { Imagen } from "./imagen";

export class DetalleCarrito {

  decaId: number;
  carrId_SicaCarrito: number;
  cantidad: number;
  codigoParte: string;
  estado: string;
  fechaCreacion: Date;
  fechaModificacion: Date;
  usuarioCreador: string;
  usuarioModificador: string;
  valorIva: number;
  valorTotal: number;
  partId: number;
  nombre: string;
  disponible: number;
  fechaDisponible : Date;
  imagenes: Imagen[];

  constructor() { }

}
